<template>
  <div class="card">
    <div class="portrait-container">
      <img :src="imgUrl(personObject.imagePath)" :alt="personObject.name" />
    </div>
    <div class="personInfo-container">
      <h2>{{ personObject.name }}</h2>
      <p class="title">{{ personObject.title }}</p>
      <p v-html="personObject.extras"></p>
    </div>
  </div>
</template>

<script>
var images = require.context(
  "../assets/TeamPortraits/",
  false,
  /\.png$|\.jpg$/
);

export default {
  props: ["personObject"],

  methods: {
    imgUrl: function (path) {
      return images("./" + path);
    },
  },
};
</script>
<style>
.card {
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.2);
  width: 340px;
  height: 370px;
  margin: 10px 20px;
}

.card img {
  height: 250px;
  margin-top: 30px;
}

.card .portrait-container {
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
}

.personInfo-container {
  padding: 0 16px;
}

.personInfo-container h2 {
  padding-bottom: 2px;
}

.personInfo-container p a {
  color: #836145;
  text-decoration: underline;
}
</style>
